import React from 'react';
const SavedTicketIcon = ({ fill = '#7f7f7f', width = 20, height = 20, opacity = 1 }) => (
    <svg width={width} height={height} viewBox="0 0 40 40">
        <g fill="none" opacity={opacity} fillRule="evenodd" strokeWidth="2" transform="translate(3.5 3)">
            <circle cx="17" cy="17" r="21" fill="#FFF" />
            <circle cx="17" cy="17" r="18" fill={fill} />
            <path strokeLinecap="round" strokeLinejoin="round" d="M24 26H10M17 7v13M23 15l-6 6-6-6" stroke="#FFF" />
        </g>
    </svg>
);

export default SavedTicketIcon;
